import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'

import Resume from '../components/cv/CV'
import { rhythm } from '../utils/typography'

class BlogIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')

    return (
      <div>
        <Helmet title={`Ville Vaarala - Security Oriented Web Developer | ${siteTitle}`}>
        <meta name="description" content="Do you need a blazingly fast web application for humans? Ville Vaarala, a full-stack change agent at Futurice, can help you." /></Helmet>
        <Resume />
      </div>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js